import { useEffect, useState } from 'react';

import { BgVideo } from '../BgVideo/BgVideo';
import { AdvtFullSize } from './AdvtFullSize/AdvtFullSize';
import { WordCloud } from './WordCloud/WordCloud';

import styles from './WordCloudWraper.module.css';

export const WordCloudWraper = ({ options, wordsInTitre }) => {
  const [visibleWords, setVisibleWords] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisibleWords(true);
    }, 2800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      <AdvtFullSize />

      <div className={styles.words}>
        {visibleWords && (
          <WordCloud options={options} wordsInTitre={wordsInTitre} />
        )}
      </div>

      <BgVideo />
    </div>
  );
};
